var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "xl12 l12 m12 s12 insety-16 border-bottom" },
    [
      _c("label", { staticClass: "bold bond-title fg70" }, [
        _vm._v(_vm._s(_vm.$t("maturity_date"))),
      ]),
      _c("div", { staticClass: "xl12 l12 m12 s12 flex-flex after-16" }, [
        _c(
          "div",
          { staticClass: "matdate" },
          [
            _c("label", { staticClass: "fg50 fs7 insety-8" }, [
              _vm._v(_vm._s(_vm.$t("from"))),
            ]),
            _c("ib-field-date", {
              staticClass: "inset-8 outset-0",
              attrs: {
                width: "100%",
                type: "text",
                uppercase: "",
                name: "startDate",
              },
              on: { input: _vm.enableEndDate, change: _vm.checkDates },
              model: {
                value: _vm.maturityDates[0],
                callback: function ($$v) {
                  _vm.$set(_vm.maturityDates, 0, $$v)
                },
                expression: "maturityDates[0]",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "outsetx-16 matdate" },
          [
            _c("label", { staticClass: "fg50 fs7 insety-8" }, [
              _vm._v(_vm._s(_vm.$t("to"))),
            ]),
            _c("ib-field-date", {
              staticClass: "inset-8 outset-0",
              attrs: {
                width: "100%",
                type: "text",
                disabled: _vm.hide,
                uppercase: "",
                name: "endDate",
              },
              on: { change: _vm.checkDates },
              model: {
                value: _vm.maturityDates[1],
                callback: function ($$v) {
                  _vm.$set(_vm.maturityDates, 1, $$v)
                },
                expression: "maturityDates[1]",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }